module.exports = __webpack_public_path__ + "bb3f2d0ad47b9259b15f44ea60994146.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/header_dashboard_2x.png
// module id = 91
// module chunks = 0 1 2 3 4